var d3 = require("d3");
var _ = require('lodash');
var legend = require("./color-legend");
var topojson = require('topojson-client');
const {TIMEPARSER,
    TIMEFORMATTER,
    selectStep1ID,
    selectStep2ID,
    selectStep3ID,
    lineChartID,
    lineBtnID,
    svgLinesID,
    gLinesID,
    riLineID,
    nonRILineID,
    lineZeroID,
    heightLineChartDiv,
    widthLineChartDiv,
    paddingSVG,
    paddingScale,
    xScaleRange,
    yScaleRange,
    translate_xAxis,
    translate_yAxis,
    COLS,
    URL_RI,
    URL_nonRIMedian,
    URL_nonRIMean,
    colors,
    strokeWidth,
    yTickFormat,
    titles,
    titlesData,
    URL_STATES,
    URL_COUNTIES,
    URL_STATEGEOJSON,
    URL_COUNTYGEOJSON,
    URL_DATESET,

} = require('./constVars')
const mapWidth = 1000;
const mapHeight = 750;
const toolTipCols = ["Change of Retail & Recreation Activities",
    "Change of Grocery & Pharmacy Activities",
"Change of Park Activities",
"Change of Transit Station Activities",
"Change of Workplace Activities",
"Change of Residential Activities"];


let setDivDims = function (divID = lineChartID, h_div = heightLineChartDiv, w_div = widthLineChartDiv, p_svg=paddingSVG) {
    d3.select(divID).attr("height", h_div);
    let svg = d3.select(divID)
        .append("svg")
        .attr("height", h_div - p_svg/2)
        .attr("width", w_div -p_svg/2)
        .attr("id", `${_.trimStart(svgLinesID, "#")}`)


}

let str2NumAndDate = function (d) {
    d.forEach((row, i) => {
        COLS.forEach(col => {
            d[i][col] = +row[col];
        })
        d[i]['date'] = TIMEPARSER(row['date']);
    });
    //no return as d is modified in place.

}

//xScale is date
let _setXScale = function (d, xScaleRange) {
    let xExtent = d3.extent(d, d => d["date"]);
    return d3.scaleTime().domain(xExtent).range(xScaleRange);


}
//yScale is dependent on the col (var) of the data.
let _setYScale = function (d, yScaleRange,col) {
        if (d.length === 1){d=d[0]}else{
            d = d[0].concat(d[1]);

        }
        let dy = d.filter(el=>!isNaN(el[col]))
        let domain_y = d3.extent(dy, el=>el[col]);
        return d3.scaleLinear()
            .domain(domain_y)
            .range(yScaleRange);


}

let setAxes = function (xScale, yScale, translate_xAxis, translate_yAxis, col) {
    let xAxis = d3.axisBottom(xScale).tickFormat(TIMEFORMATTER);
    //the default yAxe is bound to yScale_retail. consider to use transition
    let yAxis = d3.axisLeft(yScale).tickFormat(y => y[col] === 0 ? "Baseline" : `${y}%`);
    d3.select("#svgLineChart").append('g').attr('transform', translate_xAxis).attr("class", "axis axis-x").call(xAxis);
    d3.select("#svgLineChart").append("g").attr("transform", translate_yAxis).attr("class", "axis axis-y").call(yAxis)
    return {"xAxis": xAxis, "yAxis": yAxis};
}

let _setLineGenerator = function (xScale, yScale, col) {

        return d3.line().defined(d => !Number.isNaN(d[col]))
            .x(d => xScale(d["date"]))
            .y(d => yScale(d[col]))
            .curve(d3.curveBasis);

}


let _getWKData = function (arr) {
    let arrWK = [];
    arr.forEach(function (data,i){
        arrWK[i] = data.filter(d => d.date.getDay() > 0 && d.date.getDay() < 6);
    })
    return arrWK;

}

let enableLineBtn = function () {
    d3.select(lineBtnID).attr("disabled", null);
}

let _drawLineZero = function(linesG, xScale, yScale){
    //LineZero's class is line and line-zero.
    const zeroLineData = [{x: xScale.domain()[0], y: 0},
        {x: xScale.domain()[1], y: 0}];
    let penZero= d3.line().x(d => xScale(d.x)).y(d => yScale(d.y));
    let lineZeroID_ = `${_.trimStart(lineZeroID,'#')}`
    linesG.append('path').attr("class", `line ${lineZeroID_}`).attr('id',lineZeroID_)
        .datum(zeroLineData).attr("d", penZero)
        .style("fill",'none')
        .style("stroke",'#398C51')
        .style("stroke-dasharray",'10,4');

}

let drawLines = function (listArr, col){
    //listClass is an arr, so is ListArr; col is a string.
    // list ID is the IDs for all the lines to draw; listArr is all the datum to use; col is the select1 value.

    let linesG = d3.select(gLinesID);
    let xScale = _setXScale(listArr[0], xScaleRange);
    let yScale = _setYScale(listArr, yScaleRange, col);
    _updateYAxis(yScale,col);
    _updateXAxis(xScale);
    let pen = _setLineGenerator(xScale, yScale, col);
    const ids = [`${_.trimStart(riLineID, "#")}`, `${_.trimStart(nonRILineID, "#")}`];

    listArr.forEach((data, index) => {
        linesG.append("path")
            .datum(data)
            .attr("class", `line ${ids[index]}`)
            .attr("id", ids[index])
            .attr("d", pen)
            .style("stroke",colors[index] )
            .style('stroke-width',strokeWidth)
            .style("fill", "none");
    })
    _drawLineZero(linesG, xScale,yScale);
}


let addTitle = function(i1, i2){
    let isExisting = document.querySelector(".title");
    if (isExisting) {
        d3.select(".title").remove();
    }
    d3.select(svgLinesID).append("text").attr("x",  widthLineChartDiv/2).attr("y", paddingScale)
        .attr("class", "title")
        .attr("text-anchor", "middle")
        .text(`${titles[i2]} Changes over Time: ${titlesData[i1]}`);
}
let addLegend = function(v1){
    const gapBetweenTAndL = 5;
    const legendWidth = 30;
    const legendHeight = 10;
    const xStart = 130;
    const yStart = 50;
    const xyRILegend = [[xStart, yStart],[xStart+legendWidth,yStart]];
    const xyNonRILegend = [[xStart, yStart+legendHeight],[xStart+legendWidth, yStart+legendHeight]];

    let isExisting = document.querySelector(".legend");
    let svg = d3.select(svgLinesID);
    if (isExisting) {
        d3.select("g.legend").remove();
    }
    //legendRI
    svg.append("g").attr("class", 'legend').append('path').attr('class', 'legendRI')
        .attr('d', d3.line()(xyRILegend));

    //legendTextRI
    svg.select("g.legend").append('text').attr("class", 'textLegend textLegendRI')
        .attr('x', xStart-gapBetweenTAndL).attr('y', yStart).attr("text-anchor", 'end')
        .text("RI")
        .attr('dy',legendHeight/2);
    if (+v1>0){
        svg.select("g.legend").append('path').attr('class', 'legendNonRI')
            .attr("d", d3.line()(xyNonRILegend));
        svg.select("g.legend").append('text').attr("class", 'textLegend textLegendNonRI')
        .attr('x', xStart-gapBetweenTAndL).attr('y', yStart+legendHeight).attr("text-anchor", 'end')
        .text("Non-RI").attr("dy", legendHeight/2);}


}
let initAxes = function(dRI){

    let xAxis = d3.axisBottom(_setXScale(dRI,xScaleRange));
    //the default yAxe is bound to yScale_retail. consider to use transition
    let yAxis = d3.axisLeft(_setYScale([dRI], yScaleRange, COLS[0])).tickFormat(yTickFormat);
    d3.select(svgLinesID).append('g').attr('transform', translate_xAxis).attr("class", "axis axis-x").call(xAxis);
    d3.select(svgLinesID).append("g").attr("transform", translate_yAxis).attr("class", "axis axis-y").call(yAxis)

}
let _updateYAxis = function(yScale, col){
    let yAxis = d3.axisLeft(yScale).tickFormat(yTickFormat);
    d3.select('.axis-y').transition().duration(1200).ease(d3.easeSinInOut).call(yAxis);

}
let _updateXAxis = function(xScale){
    //let xAxis = d3.axisBottom(xScale).tickFormat(TIMEFORMATTER);
    let xAxis = d3.axisBottom(xScale);
    d3.select('.axis-x').transition().duration(1200).ease(d3.easeSinInOut).call(xAxis);
}

//map function
let getIDs = function(geoJSON, mode){
    if (mode==="state"){
        let ls = geoJSON.objects.states.geometries;
        return ls.map(el=>el.properties.name.replace(" ",'-'));
    }
    else{
        let ls = geoJSON.objects.counties.geometries;
        return ls.map(el=>`ID${el.id}`);

    }

}
let drawMap = function(d_topoJSON, mode){
    let scaleFactor = mode==="State"? 1200: 1200;
    let toolTipEl = d3.select(`#tooltip${mode}`);
    let mapsvg = d3.select(`#map${mode}-div`).append("svg").attr("width", mapWidth).attr("height", mapHeight)
        .attr("class", `svgMap${mode}`).attr("id", `svgMap${mode}`);
    let projection = d3.geoAlbersUsa().translate([mapWidth/2, mapHeight/2]).scale(scaleFactor);
    let geoPath = d3.geoPath(projection);
    let fips = mode==="State"? "sub_region_1": "census_fips_code";
    let level = mode==="State"? "states": "counties";
    let g = mapsvg.append("g").attr("id", `mapg${mode}`); //add a g element
    g.selectAll("path")
        .data(topojson.feature(d_topoJSON, d_topoJSON.objects[level]).features)
        .enter()
        .append('path')
        .attr('d', geoPath)
        .attr("class", 'map-path')
        .attr("id", d=>mode==="State"? d.properties.name.replace(' ', '-'): `ID${d.id}`)
        .attr("data-name", d=>mode==="State"?`${d.properties.name}`:`${d.properties.name} County`)
        .style("fill", "#ccc")
        .style("stroke", "#fff")
        .style("stroke-width",0.5 )
        .on('click', event=>{
            let mouseXY = d3.pointer(event);
            let x = mouseXY[0];
            let y = mouseXY[1];
            toolTipEl.transition().duration(200).style("opacity", .9);
            let name = d3.select("#"+event.currentTarget.id).attr("data-name");
            if (document.getElementById(event.currentTarget.id).hasAttribute('value')){
                let col_ = d3.select("#"+event.currentTarget.id).attr("col");
                let val = d3.select("#"+event.currentTarget.id).attr("value");
                toolTipEl.html(`${name}:<br>${toolTipCols[col_]}: ${val}%`).style("left", x+'px').style('top', y+"px");
            }else{
                toolTipEl.html(`${name}:<br>NA`).style("left", x+'px').style('top', y+"px");
            }



        });

    _setupZoom(mapsvg);

}
let _setupZoom = function(mapsvg) {
    const zoom = d3.zoom().scaleExtent([1,12]);
    zoom.on("zoom", (e)=>{
        const {transform, sourceEvent} = e;
        let gTarget = d3.select(sourceEvent.path[1]);
        gTarget.attr("transform", transform);
        gTarget.attr("stroke-width",1/transform.k);
        //reset tooltips
        d3.select("#tooltipState").style("opacity",0);
        d3.select("#tooltipCounty").style("opacity",0);

    });
    mapsvg.call(zoom);

}

let checkSels = function(...sels){

    return sels.every(sel=>sel!=='title');
}

let loadDates = function(dates){
    let datesArr = dates['dates'];
    datesArr.sort((a,b)=>TIMEPARSER(b)-TIMEPARSER(a));

    let dateSelState = document.getElementById(`select-date-state`);
    let dateSelCounty = document.getElementById(`select-date-county`);
    [dateSelState, dateSelCounty].forEach(el=>{
        let htmlContent = el.innerHTML;
        datesArr.forEach(d=>{
            htmlContent += `<option value="${d}">${d}</option>`;
        });
        el.innerHTML = htmlContent;
    })

}

let changeMapStyle = function(data, mode, col){
    let data_ = _.pickBy(data, (v,k)=>v!=="NaN");
    let keys = Object.keys(data_);
    let vals = Object.values(data_);
    vals = vals.map(v=>+v);
    let min_ = d3.min(vals);
    let max_ = d3.max(vals);
    max_ < 0? max_ = 1: {};
    min_ > 0? min_ = -1: {};


    let scale = d3.scaleDiverging().domain([min_, 0, max_]).interpolator(d3.interpolateRdBu);
    keys.forEach(k=>{
        let kid = mode==="state"? k.replace(" ", '-'):`ID${k}`;
        kid = "#"+kid;
        d3.select(kid).style("fill", scale(data_[k]))
            .style("stroke", "#ccc")
            .style("stroke-width",0.5)
            .attr("value", data_[k])
            .attr('col', col);
    })

    _addMapLegend(min_, max_, mode);



}
function _addMapLegend(b1, b2,mode) {
    const node = legend({
        color: d3.scaleDiverging([b1, 0, b2], d3.interpolateRdBu),
        title: "Activity Change (%)",
        tickFormat: '+f'

    });
    mode = mode==="state"? "State": "County";
    d3.select(`#legendMap${mode}`).remove();
    d3.select(`#map${mode}-div`).node().append(node);
    let legend_svg = d3.select(`#svgMap${mode} ~ svg`);
    legend_svg.attr('class', `legendMap${mode}`).attr("id", `legendMap${mode}`);
    mode==='State'?{}:document.getElementById('legend-nodata').classList.remove("invisible")

}

exports.setDivDims = setDivDims;
exports.transformStr = str2NumAndDate;
exports.setAxes = setAxes;
exports.drawLines = drawLines;
exports.getWKData = _getWKData;
exports.enableLineBtn = enableLineBtn;
exports.str2NumAndDate = str2NumAndDate;
exports.addTitle = addTitle;
exports.addLegend = addLegend;
exports.initAxes = initAxes;
exports.getIDs = getIDs;
exports.drawMap = drawMap;
exports.loadDates = loadDates;
exports.checkSels = checkSels;
exports.changeMapStyle = changeMapStyle;

